/* ==========================================================================
   DIREVULF — cyo-banner.js
   Loaded by sections/cyo-banner.liquid on /pages/create-your-own.

   1. LINE-UP. With no video or picture set, the banner draws the garments
      named in its "Line-up" setting with the studio's own mockup library
      (window.DVMockups), each in its chosen colour, on the drafting grid.
   2. LESS MOTION. A banner video is paused for shoppers who ask for less
      motion (prefers-reduced-motion).
   3. STUDIO LAYOUT. The sticky header's height is kept in
      --dv-cb-sticky-top for the studio's pinned preview (cyo-banner.css).

   The button needs nothing from here: it is the studio's own opener.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dvCyoBanner) return;
  window.__dvCyoBanner = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function waitFor(test, done, timeout) {
    var t0 = Date.now();
    (function poll() {
      var ok = false;
      try { ok = !!test(); } catch (e) { ok = false; }
      if (ok) { done(); return; }
      if (Date.now() - t0 > (timeout || 12000)) return;
      window.setTimeout(poll, 80);
    })();
  }

  /* ------------------------------------------------------------- line-up */
  /* Up to three garments: one in front, the others just behind it. */
  function paintLineup(canvas, items) {
    var M = window.DVMockups;
    var list = items.filter(function (it) { return it && it.tpl && M.has(it.tpl); }).slice(0, 3);
    if (!list.length) return;
    var builds = list.map(function (it) {
      return M.build(it.tpl, M.viewsOf(it.tpl)[0], { colour: it.colour || null });
    });
    if (builds.some(function (b) { return !b; })) return;

    var token = 0;
    function draw() {
      var my = ++token;
      Promise.all(builds.map(function (b) { return b.images; })).then(function (ims) {
        if (my !== token) return;
        var box = canvas.getBoundingClientRect();
        var dpr = Math.min(2, window.devicePixelRatio || 1);
        var W = Math.round(box.width * dpr), H = Math.round(box.height * dpr);
        if (!W || !H) return;
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, W, H);

        var n = builds.length;
        /* The front garment (the middle one of three, the second of two) is
           centred; the others stand 62% of its width to each side, at 80%
           size and a little higher, drawn first so the front one overlaps
           them. The group is sized to fit the canvas both ways. */
        var front = n === 3 ? 1 : n - 1;
        var ar = builds[front].vb[0] / builds[front].vb[1];
        var span = n === 1 ? 1 : (n === 2 ? 0.62 + 0.9 : 2 * 0.62 + 0.8);
        var wf = Math.min(W / span, H * 0.96 * ar);
        var hf = wf / ar;
        var cxs = n === 1 ? [W / 2] : (n === 2 ? [W / 2 - 0.31 * wf, W / 2 + 0.31 * wf] : [W / 2 - 0.62 * wf, W / 2, W / 2 + 0.62 * wf]);
        var order = [];
        for (var i = 0; i < n; i++) if (i !== front) order.push(i);
        order.push(front);
        order.forEach(function (i) {
          var b = builds[i], im = ims[i];
          var isFront = i === front;
          var h = isFront ? hf : hf * 0.8;
          var w = h * b.vb[0] / b.vb[1];
          var x = cxs[i] - w / 2;
          var y = (H - hf) / 2 + (isFront ? 0 : hf * 0.04);
          ['base', 'details', 'shade'].forEach(function (p) { ctx.drawImage(im[p], x, y, w, h); });
        });
        canvas.classList.add('is-ready');
      }, function () {});
    }
    draw();
    if (window.ResizeObserver) new window.ResizeObserver(draw).observe(canvas);
    else window.addEventListener('resize', draw);
  }

  function initLineups() {
    $$('[data-cyo-lineup]').forEach(function (canvas) {
      var node = canvas.parentNode && $('[data-cyo-lineup-data]', canvas.parentNode);
      var items = [];
      try { items = JSON.parse(node ? node.textContent : '[]') || []; } catch (e) { items = []; }
      paintLineup(canvas, items);
    });
  }

  /* --------------------------------------------------------- less motion */
  function quietVideos() {
    if (!reduceMotion) return;
    $$('.dv-cyo-banner video').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) { /* not started */ }
    });
  }

  /* --------------------------------------------------------- studio layout */
  function trackHeader() {
    var hdr = $$('.shopify-section-group-header-group').filter(function (el) {
      return window.getComputedStyle(el).position === 'sticky';
    })[0];
    if (!hdr) return;
    function set() {
      document.documentElement.style.setProperty('--dv-cb-sticky-top', Math.round(hdr.getBoundingClientRect().height) + 'px');
    }
    set();
    if (window.ResizeObserver) new window.ResizeObserver(set).observe(hdr);
    else window.addEventListener('resize', set);
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    quietVideos();
    trackHeader();
    if ($('[data-cyo-lineup]')) {
      waitFor(function () { return window.DVMockups && window.DVMockups.build && window.DVMockups.viewsOf; }, initLineups);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
